<div bsModal [config]="UiConstants.modalConfig" #fieldDialog="bs-modal" (onHide)="onModalHide($event)"
     class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" *ngIf="visible">
      <div class="modal-header">
        <h4 class="modal-title">{{dialogTitleDictionaryKey | translate}}</h4>
        <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [formGroup]="formGroup">
        <div class="card-body p-0">

          <h6 class="mb-1">{{'COMMON_BASIC_DATA' | translate}}</h6>

          <div class="row">

            <!-- region Title -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.TITLE) || hasLocalFieldError('title')}">
              <label>{{'COMMON_NAME' | translate}}</label>
              <input type="text" class="form-control" placeholder="{{'COMMON_NAME' | translate}}"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.TITLE) || hasLocalFieldError('title') }"
                     [(ngModel)]="fieldModel.title" formControlName="title"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.TITLE)"
                     (blur)="onTitleBlur()"
                     trim="blur" validateOnBlur [validateFormControl]="formGroup.controls['title']">
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.TITLE)">
                {{getFieldErrorText(Form.FieldValidatedField.TITLE)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('title')">
                <span *ngIf="hasLocalFieldError('title', 'required')">{{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}</span>
              </div>
            </div>
            <!-- endregion Title -->

            <!-- region field width -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_FIELD_WIDTH' | translate}}</label>
              <select class="form-control" [(ngModel)]="fieldModel.fieldWidthType"
                      [ngModelOptions]="{standalone: true}"
                      id="fieldWidth" name="fieldWidth" #fieldWidth="ngModel">
                <option *ngFor="let widthType of fieldWidthTypes" [ngValue]="widthType">{{widthType.textDictionaryKey |
                  translate}}
                </option>
              </select>
            </div>
            <!-- endregion field width -->

            <!-- region display on new row -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_DISPLAY_ON_NEW_ROW' | translate}}</label>
              <br>
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input" [(ngModel)]="fieldModel.displayOnNewRow"
                       [ngModelOptions]="{standalone: true}"
                       #displayOnNewRow="ngModel" id="displayOnNewRow" name="displayOnNewRow">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
            <!-- endregion display on new row -->

          </div> <!-- ./row end -->

          <div class="row">
            <!-- region Field validation type (admin) -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_ADMIN_FIELD_VALIDATION_TYPE' | translate}}</label>
              <select class="form-control"
                      [(ngModel)]="fieldModel.adminFormFieldValidationType" (change)="onAdminFormFieldValidationTypeChanged()"
                      [ngModelOptions]="{standalone: true}"
                      #adminFormFieldValidationType="ngModel" id="adminFormFieldValidationType" name="adminFormFieldValidationType">
                <option *ngFor="let vt of fieldValidationTypes" [ngValue]="vt">{{getFieldValidationTypeDictionaryKey(vt) | translate}}</option>
              </select>
            </div>
            <!-- endregion Field validation type (admin) -->

            <!-- region Field validation type (mobile) -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_MOBILE_FIELD_VALIDATION_TYPE' | translate}}</label>
              <select class="form-control"
                      [(ngModel)]="fieldModel.mobileFormFieldValidationType" (change)="onMobileFormFieldValidationTypeChanged()"
                      [ngModelOptions]="{standalone: true}"
                      #adminFormFieldValidationType="ngModel" id="mobileFormFieldValidationType" name="mobileFormFieldValidationType">
                <option *ngFor="let vt of fieldValidationTypes" [ngValue]="vt">{{getFieldValidationTypeDictionaryKey(vt) | translate}}</option>
              </select>
            </div>
            <!-- endregion Field validation type (mobile) -->

            <!-- region Field validation type (helpdesk) -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_HELPDESK_FIELD_VALIDATION_TYPE' | translate}}</label>
              <select class="form-control"
                      [(ngModel)]="fieldModel.helpdeskFormFieldValidationType"
                      [ngModelOptions]="{standalone: true}"
                      #helpdeskFormFieldValidationType="ngModel" id="helpdeskFormFieldValidationType" name="helpdeskFormFieldValidationType">
                <option *ngFor="let vt of fieldValidationTypes" [ngValue]="vt">{{getFieldValidationTypeDictionaryKey(vt) | translate}}</option>
              </select>
            </div>
            <!-- endregion Field validation type (helpdesk) -->

            <!-- region visible on master detail (mobile) -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_MOBILE_VISIBLE_ON_MASTER_DETAIL' | translate}}</label>
              <br>
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input" [(ngModel)]="fieldModel.mobileVisibleOnMasterDetail"
                       [ngModelOptions]="{standalone: true}"
                       #mobileVisibleOnMasterDetail="ngModel" id="mobileVisibleOnMasterDetail" name="mobileVisibleOnMasterDetail">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
            <!-- endregion visible on master detail (mobile) -->
          </div> <!-- ./row end -->


          <div class="row">

            <!-- region API export name -->
            <div class="form-group col-md-6" [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.API_EXPORT_NAME) || hasLocalFieldError('apiExportName')}">
              <label>{{'FORM_ITEM_COMMON_EXPORT_NAME' | translate}}</label>
              <input type="text" class="form-control"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.API_EXPORT_NAME) || hasLocalFieldError('apiExportName') }"
                     [(ngModel)]="fieldModel.apiExportName"
                     formControlName="apiExportName"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.API_EXPORT_NAME)"
                     placeholder="{{'FORM_ITEM_COMMON_EXPORT_NAME' | translate}}"
                     trim="blur" validateOnBlur [validateFormControl]="formGroup.controls['apiExportName']"
              >
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.API_EXPORT_NAME)">
                {{getFieldErrorText(Form.FieldValidatedField.API_EXPORT_NAME)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('apiExportName')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
            <!-- endregion API export name -->

            <!-- region PDF export name -->
            <div class="form-group col-md-6" [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME) }">
              <label>{{'FORM_ITEM_COMMON_PDF_EXPORT_NAME' | translate}}</label>
              <input type="text" class="form-control"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngModelOptions]="{standalone: true}"
                     [(ngModel)]="fieldModel.pdfExportName"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME)"
                     placeholder="{{'FORM_ITEM_COMMON_PDF_EXPORT_NAME' | translate}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME) }">
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME)">
                {{getFieldErrorText(Form.FieldValidatedField.PDF_EXPORT_NAME)}}
              </div>
            </div>
            <!-- endregion PDF export name -->

          </div> <!-- ./row end -->

          <div class="row">

            <!-- region placeholder -->
            <div class="form-group col-md-6">
              <label>{{'FORM_ITEM_COMMON_PLACEHOLDER' | translate}}</label>
              <input type="text" class="form-control"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [(ngModel)]="fieldModel.placeholder"
                     [ngModelOptions]="{standalone: true}" #placeholder="ngModel" name="placeholder" id="placeholder"
                     placeholder="{{'FORM_ITEM_COMMON_PLACEHOLDER' | translate}}">
            </div>
            <!-- endregion placeholder -->

            <!-- region default value -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.DEFAULT_VALUE) || hasLocalFieldError('defaultValue') }">
              <label>{{'FORM_ITEM_COMMON_DEFAULT_VALUE' | translate}}</label>
              <input type="text" class="form-control"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.DEFAULT_VALUE) || hasLocalFieldError('defaultValue') }"
                     [(ngModel)]="fieldModel.defaultValue"
                     formControlName="defaultValue"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.DEFAULT_VALUE)"
                     placeholder="{{'FORM_ITEM_COMMON_DEFAULT_VALUE' | translate}}"
                     trim="blur" validateOnBlur [validateFormControl]="formGroup.controls['defaultValue']">
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.DEFAULT_VALUE)">
                {{getFieldErrorText(Form.FieldValidatedField.DEFAULT_VALUE)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('defaultValue')">
                {{'FORM_FIELD_VALIDATION_DEFAULT_VALUE_LENGTH' | translate}}
              </div>
            </div>
            <!-- endregion default value -->

          </div>

          <div class="row">

            <!-- region Description -->
            <div class="form-group col-md-6">
              <label>{{'COMMON_DESCRIPTION' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="fieldModel.description"
                     [ngModelOptions]="{standalone: true}" #description="ngModel"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     placeholder="{{'COMMON_DESCRIPTION' | translate}}"
                     name="description" id="description">
            </div>
            <!-- endregion Description -->

            <!-- region hint -->
            <div class="form-group col-md-6">
              <label>{{'FORM_ITEM_COMMON_HINT' | translate}}</label>
              <textarea rows='1' class="form-control" [(ngModel)]="fieldModel.hint"
                        [ngModelOptions]="{standalone: true}" #hint="ngModel"
                        placeholder="{{'FORM_ITEM_COMMON_HINT' | translate}}"
                        name="hint" id="hint"></textarea>
            </div>
            <!-- endregion hint -->

          </div> <!-- ./row end -->

          <h6 class="mb-1 mt-1">{{'FORM_ITEM_CREATE_DOCUMENT_EXTRA_DATA' | translate}}</h6>

          <div class="row">

            <!-- region min length -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.MIN_LENGTH) || hasLocalFieldError('minLength') }">
              <label>{{'FORM_ITEM_COMMON_MIN_LENGTH' | translate}}</label>
              <input type="number" class="form-control"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.MIN_LENGTH) || hasLocalFieldError('minLength') }"
                     [(ngModel)]="fieldModel.minLengthText"
                     formControlName="minLength"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.MIN_LENGTH)"
                     placeholder="{{'FORM_ITEM_COMMON_MIN_LENGTH' | translate}}"
                     trim="blur" validateOnBlur [validateFormControl]="formGroup.controls['minLength']">
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.MIN_LENGTH)">
                {{getFieldErrorText(Form.FieldValidatedField.MIN_LENGTH)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('minLength')">
                <span *ngIf="hasLocalFieldError('minLength', 'min')">
                  {{'COMMON_VALIDATION_MESSAGE_NUMBER_NOT_POSITIVE' | translate}}
                </span>
                <span *ngIf="hasLocalFieldError('minLength', 'max')">
                  {{'FORM_FIELD_VALIDATION_MIN_VALUE' | translate}}
                </span>
              </div>
            </div>
            <!-- endregion min length -->

            <!-- region max length -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.MAX_LENGTH) || hasLocalFieldError('maxLength') }">
              <label>{{'FORM_ITEM_COMMON_MAX_LENGTH' | translate}}</label>
              <input type="number" class="form-control"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.MAX_LENGTH) || hasLocalFieldError('maxLength') }"
                     [(ngModel)]="fieldModel.maxLengthText"
                     formControlName="maxLength"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.MAX_LENGTH)"
                     placeholder="{{'FORM_ITEM_COMMON_MAX_LENGTH' | translate}}"
                     trim="blur" validateOnBlur [validateFormControl]="formGroup.controls['maxLength']">
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.MAX_LENGTH)">
                {{getFieldErrorText(Form.FieldValidatedField.MAX_LENGTH)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('maxLength', 'min')">
                <span *ngIf="parseNumber(fieldModel.minLengthText)">
                  {{'FORM_FIELD_VALIDATION_MAX_VALUE_MIN' | translate}}
                </span>
                <span *ngIf="!parseNumber(fieldModel.minLengthText)">
                  {{'FORM_FIELD_VALIDATION_MAX_VALUE_ABSOLUTE_MIN' | translate}}
                </span>
              </div>
            </div>
            <!-- endregion max length -->

            <!-- region multiline -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_MULTILINE' | translate}}</label>
              <br>
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input" [(ngModel)]="fieldModel.multiline"
                       [ngModelOptions]="{standalone: true}"
                       #active="ngModel" id="multiline" name="multiline">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
            <!-- endregion multiline -->

            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_SHOW_ON_RECEIPT' | translate}}
                <i class="icomoon icomoon-info info-icon" popover="{{'FORM_EDIT_SHOW_ON_RECEIPT_INFO' | translate}}"
                   triggers="mouseenter:mouseleave" container="body" placement="right"></i></label>
              <br>
              <label class="switch switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input" [(ngModel)]="fieldModel.showOnReceipt"
                       [ngModelOptions]="{standalone: true}"
                       #showOnReceipt="ngModel" id="showOnReceipt" name="showOnReceipt">
                <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
                <span class="switch-handle"></span>
              </label>
            </div>

          </div> <!-- ./row end -->

          <div class="row">

            <!-- region Field input capitalization mode -->
            <div class="form-group col-md-6">
              <label>{{'FORM_FIELD_INPUT_CAPITALIZE_MODE' | translate}}</label>
              <select class="form-control"
                      [(ngModel)]="fieldModel.inputCapitalizeMode"
                      [ngModelOptions]="{standalone: true}"
                      #inputCapitalizeMode="ngModel" id="inputCapitalizeMode" name="inputCapitalizeMode">
                <option *ngFor="let icm of fieldInputCapitalizationModes" [ngValue]="icm">{{getFieldInputCapitalizeModeKey(icm) | translate}}</option>
              </select>
            </div>
            <!-- endregion Field input capitalization mode (mobile) -->

          </div> <!-- ./row end -->

        </div> <!-- ./card-body end -->
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDialog()">{{'COMMON_BUTTON_CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" #functionButton (click)="saveField()">{{'COMMON_BUTTON_SAVE' |
          translate}}
        </button>
      </div>

    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
